module.exports = config => {
  let c = config || {};
  const defaults = require('./config/config');
  for (const name in defaults) {
    if (!(name in c)) c[name] = defaults[name];
  }
  var Canvas = require('./model/Canvas'),
    CanvasView = require('./view/CanvasView');
  var canvas;

  return {
    init() {
      let c = config || {};
      canvas = new Canvas(c);
      CanvasView = new CanvasView({
        model: canvas,
        config: c
      });
      return this;
    },

    render() {
      window.addEventListener('load', function() {
        return CanvasView.render().el;
      });
      
    }
  };
};
